import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { routerReducer } from 'react-router-redux'

import { ambassadors } from 'Reducers/Ambassador/reducer'
import { auth } from 'Reducers/Auth/reducer'
import { campaigns } from 'Reducers/Campaigns/reducer'
import { clients } from 'Reducers/Clients/reducer'
import { document } from 'Reducers/Document/reducer'
import { errors } from 'Reducers/Errors/reducer'
import { header } from 'Reducers/Header/reducer'
import { inventory } from 'Reducers/Inventory/reducer'
import { locations } from 'Reducers/Location/reducer'
import { missions } from 'Reducers/Mission/reducer'
import { chat } from 'Reducers/Chat/reducer'
import { city } from './City/reducer'
import { rosters } from 'Reducers/Roster/reducer'
import { countries } from 'Reducers/Countries/reducer'
import { uiBlock } from 'Reducers/UIBlock/reducer'
import { users } from 'Reducers/Users/reducer'
import { pickupTimes } from 'Reducers/PickupTimes/reducer'
import { upload } from 'Reducers/Upload/reducer'
import { xero } from 'Reducers/Xero/reducer'
import { jobs } from 'Reducers/Jobs/reducer'
import { sync } from 'Reducers/Sync/reducer'
import { ui } from 'Reducers/UI/reducer'
import { metricResults } from 'Reducers/MetricResults/reducer'
import { metrics } from 'Reducers/Metric/reducer'
import { cityPlans } from 'Reducers/CityPlans/reducer'
import { conversions } from 'Reducers/Conversions/reducer'
import { permitCosts } from './PermitCosts/reducer'
import { legalDocument } from './LegalDocument/reducer'
import { reducer as websockets } from '../shared/websockets'

const innerReducer = combineReducers({
  form: formReducer,
  routing: routerReducer,
  ambassadors,
  auth,
  campaigns,
  chat,
  city,
  clients,
  document,
  errors,
  header,
  inventory,
  locations,
  missions,
  rosters,
  countries,
  uiBlock,
  users,
  pickupTimes,
  upload,
  xero,
  jobs,
  sync,
  ui,
  metricResults,
  metrics,
  cityPlans,
  conversions,
  permitCosts,
  legalDocument,
  websockets,
})

export const rootReducer = function(state, action) {
  return innerReducer(state, action)
}
